const premierLeadsListStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    attentionLeadsList: [],
    openLeadsList: [],
    onHoldLeadsList: [],
    wonLeadsList: [],
    lostLeadsList: [],
    closedLeadsList: [],
    leadCohorts: [],
  },
  mutations: {
    setAttentionLeadsList: (state, leadsListObj) => {
      state.attentionLeadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
    setOpenLeadsList: (state, leadsListObj) => {
      state.openLeadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
    setOnHoldLeadsList: (state, leadsListObj) => {
      state.onHoldLeadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
    setWonLeadsList: (state, leadsListObj) => {
      state.wonLeadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
    setLostLeadsList: (state, leadsListObj) => {
      state.lostLeadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
    setClosedLeadsList: (state, leadsListObj) => {
      state.closedLeadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
    setLeadCohorts: (state, leadsListObj) => {
      state.leadCohorts = leadsListObj; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadPremierLeadsList(context, payload) {
      const data = {};

      /* leadMode:
      * Attention - all attention leads in one list, return empty list if not existed.
      * Normal - all non-attention leads in one list, return empty list if not existed.
      * Both - all leads in two lists, one for attention on the top and one for normal leads.
               Two lists will always be returned even one could contain empty list.
      * All - all leads in one list including attention and normal leads
      * not set/null - for premier dashboard as a backwards compatibility with old data structure. */

      data.leadMode = payload.leadMode ? payload.leadMode : 'All';
      data.limit = payload.limit ? payload.limit : 5;

      if (payload.statusFilter) {
        data.statusFilter = payload.statusFilter;
      }

      if (payload.agentKey) {
        data.agentKey = payload.agentKey;
      }

      return apiServices.oa.user.getLeadActivity(payload.userKey, data, true)
        .then((leadActivityFullResponse) => {
          if (leadActivityFullResponse) {
            const list = {
              leads: leadActivityFullResponse.data[0]
                ? leadActivityFullResponse.data[0].leadActivities : [],
              total: leadActivityFullResponse.data[0]
                ? leadActivityFullResponse.data[0].totalCount : 0,
            };

            const attentionList = {
              leads: [],
              total: 0,
            };


            if (data.leadMode === 'Both' || payload.leadMode === 'Attention') {
              // Do we have Attention leads?
              if (leadActivityFullResponse.data.length > 1) {
              // Set Normal leads
                list.total = leadActivityFullResponse.data[1].totalCount;
                list.leads = leadActivityFullResponse.data[1].leadActivities;
              }

              // Set Leads which requier attention
              attentionList.leads = leadActivityFullResponse.data[0].leadActivities;
              attentionList.total = leadActivityFullResponse.data[0].totalCount;

              context.commit('setAttentionLeadsList', attentionList);
            }

            switch (payload.statusFilter) {
              case 'Open':
                context.commit('setOpenLeadsList', list);
                break;
              case 'OnHold':
                context.commit('setOnHoldLeadsList', list);
                break;
              case 'Closed':
                context.commit('setClosedLeadsList', list);
                break;
              case 'Won':
                context.commit('setWonLeadsList', list);
                break;
              case 'Lost':
                context.commit('setLostLeadsList', list);
                break;
              default:
                break;
            }
          }
        }, (err) => {
        // reject(err);
          console.log(err);
        });
    }, 
    async loadMoreLeadsList(context, payload) {
      const data = {};
      data.offset = payload.offset;
      data.leadMode = payload.leadMode ? payload.leadMode : 'All';
      data.limit = payload.limit ? payload.limit : 5;

      if (payload.statusFilter) {
        data.statusFilter = payload.statusFilter;
      }

      if (payload.agentKey) {
        data.agentKey = payload.agentKey;
      }

      return apiServices.oa.user.getLeadActivity(payload.userKey, data, true)
        .then((leadActivityFullResponse) => {
          if (leadActivityFullResponse) {
            const list = {};
            list.total = leadActivityFullResponse.data[0].totalCount;

            const newLeads = leadActivityFullResponse.data[0].leadActivities;

            switch (payload.statusFilter) {
              case 'Open':
                list.leads = this.state.premierLeadsListStore.openLeadsList.leads;
                break;
              case 'OnHold':
                list.leads = this.state.premierLeadsListStore.onHoldLeadsList.leads;
                break;
              case 'Closed':
                list.leads = this.state.premierLeadsListStore.closedLeadsList.leads;
                break;
              case 'Won':
                list.leads = this.state.premierLeadsListStore.wonLeadsList.leads;
                break;
              case 'Lost':
                list.leads = this.state.premierLeadsListStore.lostLeadsList.leads;
                break;
              default:
                break;
            }

            if (payload.leadMode === 'Attention') {
              list.leads = this.state.premierLeadsListStore.attentionLeadsList.leads;
            }

            // Add newly load leads to existing Array
            newLeads.forEach((lead) => {
              list.leads.push(lead);
            });
          }
        }, (err) => {
        // reject(err);
          console.log(err);
        });
    },
    async loadLeadCohort(context, payload) {
      const data = {};
      
      if (payload.userKey) {
        data.userKey = payload.userKey;
      }
      return apiServices.oa.user.getLeadCohorts(data.userKey, { sincePremier: true })
        .then((response) => {
          if(response) {
            context.commit('setLeadCohorts', response[0]);
          }
        }, (err) => {
          // reject(err);
            console.log(err);
        });
    },
    clearLeadsList(context, payload) {
      context.commit('setAttentionLeadsList', []);
      context.commit('setOpenLeadsList', []);
      context.commit('setOnHoldLeadsList', []);
      context.commit('setLostLeadsList', []);
      context.commit('setWonLeadsList', []);
      context.commit('setClosedLeadsList', []);
    },
    refreshLeadsList(context, payload) {
      let isStateChange = false;
      let isStageChange = false;

      const newPayload = {
        userKey: payload.userKey,
        agentKey: payload.agentKey,
        newLam: payload.lam,
        newStatusFilter: null,
        oldLam: null,
        oldStatusFilter: null,
      };

      // Do we have attention leads?
      if (payload.attentionLams.leads) {
        // Yes - Lets see if the old Lams is in here
        const findOldLam = payload.attentionLams.leads.filter(
          lead => lead.lam.id === payload.lam.id,
        );
        // Did we find it?
        if (findOldLam.length !== 0) {
          newPayload.oldStatusFilter = 'Attention';
          newPayload.oldLam = payload.attentionLams;
          isStageChange = findOldLam[0].lam.leadAgentLeadStageId !== newPayload.newLam.stagetypeid;
          isStateChange = findOldLam[0].lam.leadAgentLeadStateId !== newPayload.newLam.statetypeid;
        }
      }

      // Do we have open leads and not found the updated lead yet?
      if (payload.openLams.leads && !newPayload.oldLam) {
        // Yes - Lets see if the old Lams is in here
        const findOldLam = payload.openLams.leads.filter(
          lead => lead.lam.id === payload.lam.id,
        );

        // Did we find it?
        if (findOldLam.length !== 0) {
          newPayload.oldStatusFilter = 'Open';
          newPayload.oldLam = payload.openLams;
          isStageChange = findOldLam[0].lam.leadAgentLeadStageId !== newPayload.newLam.stagetypeid;
          isStateChange = findOldLam[0].lam.leadAgentLeadStateId !== newPayload.newLam.statetypeid;
        }
      }

      // If we have on hold leads and not found the update lead
      if (payload.onHoldLams.leads && !newPayload.oldLam) {
        // Lets see if the update lead is here
        const findOldLam = payload.onHoldLams.leads.filter(
          lam => lam.lead.id === payload.lam.leadid,
        );

        // Did we find it?
        if (findOldLam.length !== 0) {
          newPayload.oldStatusFilter = 'OnHold';
          newPayload.oldLam = payload.onHoldLams;
          isStageChange = findOldLam[0].lam.leadAgentLeadStageId !== newPayload.newLam.stagetypeid;
          isStateChange = findOldLam[0].lam.leadAgentLeadStateId !== newPayload.newLam.statetypeid;
        }
      }

      if (payload.lostLams.leads && !newPayload.oldLam) {
        // Lets see if the update lead is here
        const findOldLam = payload.lostLams.leads.filter(
          lam => lam.lead.id === payload.lam.leadid,
        );

        // Did we find it?
        if (findOldLam.length !== 0) {
          newPayload.oldStatusFilter = 'Lost';
          newPayload.oldLam = payload.lostLams;
          isStageChange = findOldLam[0].lam.leadAgentLeadStageId !== newPayload.newLam.stagetypeid;
          isStateChange = findOldLam[0].lam.leadAgentLeadStateId !== newPayload.newLam.statetypeid;
        }
      }

      if (payload.wonLams.leads && !newPayload.oldLam) {
        // Lets see if the update lead is here
        const findOldLam = payload.wonLams.leads.filter(
          lam => lam.lead.id === payload.lam.leadid,
        );

        // Did we find it?
        if (findOldLam.length !== 0) {
          newPayload.oldStatusFilter = 'Won';
          newPayload.oldLam = payload.wonLams;
          isStageChange = findOldLam[0].lam.leadAgentLeadStageId !== newPayload.newLam.stagetypeid;
          isStateChange = findOldLam[0].lam.leadAgentLeadStateId !== newPayload.newLam.statetypeid;
        }
      }

      if (payload.closedLams.leads && !newPayload.oldLam) {
        // Lets see if the update lead is here
        const findOldLam = payload.closedLams.leads.filter(
          lam => lam.lead.id === payload.lam.leadid,
        );

        // Did we find it?
        if (findOldLam.length !== 0) {
          newPayload.oldStatusFilter = 'Closed';
          newPayload.oldLam = payload.closedLams;
          isStageChange = findOldLam[0].lam.leadAgentLeadStageId !== newPayload.newLam.stagetypeid;
          isStateChange = findOldLam[0].lam.leadAgentLeadStateId !== newPayload.newLam.statetypeid;
        }
      }

      // Did we find the lead and was there lam change?
      if (newPayload.oldLam && (isStageChange || isStateChange)) {
        // Lets get the newStatusFilter
        if (payload.wonLams.leads && newPayload.newLam.statetypeid === 1 && newPayload.newLam.stagetypeid === 6) {
          // Won (Open and listed)
          newPayload.newStatusFilter = 'Won';
        } else if (payload.openLams.leads && newPayload.newLam.statetypeid === 1) {
        // Open/Active (open)\
          newPayload.newStatusFilter = 'Open';
        } else if (payload.closedLams.leads && newPayload.newLam.statetypeid === 3) {
          // Closed Status
          newPayload.newStatusFilter = 'Closed';
        } else if (payload.onHoldLams.leads && newPayload.newLam.statetypeid === 5) {
          // onHold Status
          newPayload.newStatusFilter = 'OnHold';
        } else if (payload.lostLams.leads && newPayload.newLam.statetypeid === 2) {
          // Lost
          newPayload.newStatusFilter = 'Lost';
        }

        console.log(newPayload);

        // Do we need to Update anything?
        if (newPayload.newStatusFilter === newPayload.oldStatusFilter) {
          console.log('same');
          // Update exsisting lead in exsisitng list
          context.dispatch('refreshExsistingLamInPremierList', newPayload);
        } else if (newPayload.oldStatusFilter === 'Attention') {
          console.log('Attention');
          // Reload new list
          if (newPayload.newStatusFilter !== null) {
            context.dispatch('reloadLeadsInPremierList', newPayload);
          }

          const attentionPayload = newPayload;
          attentionPayload.newStatusFilter = newPayload.oldStatusFilter;
          context.dispatch('reloadLeadsInPremierList', attentionPayload);
        } else if (newPayload.newStatusFilter !== null) {
          // Reload new list
          context.dispatch('reloadLeadsInPremierList', newPayload).then(() => {
            // Remove from old list
            context.dispatch('removeLeadFromPremierList', newPayload);
          });
        }
      }
    },
    refreshExsistingLamInPremierList(context, payload) {
      // eslint-disable-next-line no-restricted-syntax
      for (const lead of payload.oldLam.leads) {
        if (lead.lam.id === payload.newLam.id) {
          console.log(lead);

          // Update Stage Changes
          lead.lam.leadAgentLeadStage = payload.newLam.stagetype;
          lead.lam.leadAgentLeadStageId = payload.newLam.stagetypeid;

          // Double check if these od defo the same values
          lead.lam.agentAcceptedDate = payload.newLam.leadaccepteddate;

          // Update State Change
          lead.lam.leadAgentLeadState = payload.newLam.statetype;
          lead.lam.leadAgentLeadStateId = payload.newLam.statetypeid;

          // lead.lam.attemptedAfterMinutes
          // lead.lam.attemptedPosition
        }
      }

      switch (payload.oldStatusFilter) {
        // Active / Open
        case 'Open':
          context.commit('setOpenLeadsList', payload.oldLam);
          break;
        // OnHold
        case 'OnHold':
          context.commit('setOnHoldLeadsList', payload.oldLam);
          break;
        // Closed
        case 'Closed':
          context.commit('setClosedLeadsList', payload.oldLam);
          break;
        case 'Won':
          context.commit('setWonLeadsList', payload.oldLam);
          break;
        default:
          break;
      }
    },
    removeLeadFromPremierList({ commit }, payload) {
      const newLeadsList = {
        leads: payload.oldLam.leads.filter(
          lam => lam.lead.id !== payload.newLam.leadid,
        ),
        total: payload.oldLam.total - 1,
      };

      switch (payload.oldStatusFilter) {
        // Active / Open
        case 'Open':
          commit('setOpenLeadsList', newLeadsList);
          break;
        // OnHold
        case 'OnHold':
          commit('setOnHoldLeadsList', newLeadsList);
          break;
        // Closed
        case 'Closed':
          commit('setClosedLeadsList', newLeadsList);
          break;
        case 'Won':
          commit('setWonLeadsList', newLeadsList);
          break;
        default:
          break;
      }
    },
    reloadLeadsInPremierList(context, payload) {
      const newPayload = {
        userKey: payload.userKey,
        agentKey: payload.agentKey,
        statusFilter: payload.newStatusFilter,
      };

      switch (payload.newStatusFilter) {
        case 'Open':
          newPayload.limit = this.state.premierLeadsListStore.openLeadsList.leads.length;
          newPayload.leadMode = 'Normal';
          break;
        case 'OnHold':
          newPayload.limit = this.state.premierLeadsListStore.onHoldLeadsList.leads.length;
          break;
        case 'Closed':
          newPayload.limit = this.state.premierLeadsListStore.closedLeadsList.leads.length;
          break;
        case 'Won':
          newPayload.limit = this.state.premierLeadsListStore.wonLeadsList.leads.length;
          break;
        case 'Attention':
          console.log('2 - reload attention list');
          newPayload.limit = this.state.premierLeadsListStore.attentionLeadsList.leads.length;
          newPayload.statusFilter = 'Open';
          newPayload.leadMode = 'Attention';
          break;
        default:
          break;
      }

      newPayload.limit = newPayload.limit < 5 ? 5 : newPayload.limit;
      context.dispatch('loadPremierLeadsList', newPayload);
    },
  },
}));

export default premierLeadsListStore;
